import { QuestionResponse } from "../../types";
import { useSurveyHandler } from "../../hooks/useSurveyHandler";

import styles from "./question.module.scss";

import QuestionDisplay from "../QuestionDisplay/QuestionDisplay";
import AnswerInputList from "../AnswerInputList/AnswerInputList";
import NavigationButtons from "../NavigationButtons/NavigationButtons";
import { ActionCall, Alert, Button, Modal } from "cdhs-ui-library";
import { useEffect, useState } from "react";
import { BsBookmark } from "react-icons/bs";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { auth } from "../../store/user/userSlice";
import { useTranslations } from "../../contexts/LanguageContext";
import { ROUTES } from "../../config/routes";
import { useNavigate } from "react-router";



function Question(props: Partial<QuestionResponse>) {
  const t = useTranslations();

  const [openModal, setOpenModal] = useState<boolean>(false)
  const [openDeclineModal, setOpenDeclineModal] = useState<boolean>(false) // New state for decline modal
  const [declineModalContent, setDeclineModalContent] = useState({
    title: "",
    description: "",
    yesCaption: "",
    noCaption: ""
  });
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const user = useAppSelector(state => state.user.user)
  const isDashboardUser = useAppSelector(state => state.user.isDashboardLaunch)

  const handleSaveAndLogOut = async () => {
    await dispatch(auth({ SessionId: user?.SessionId, ClientId: user?.ClientId, LoginAttempt: false }))
    if (isDashboardUser){
      navigate(ROUTES.HOME)
    }
  }


  const { selectedAnswers, setSelectedAnswers, errorMessage, onRadioChange, onCheckboxChange, onQuestionSubmit, declineModalInfo, handleDeclineSubmit } = useSurveyHandler()
  useEffect(() => {
    if (declineModalInfo) {
      setDeclineModalContent(declineModalInfo);
      setOpenDeclineModal(true);
    }
  }, [declineModalInfo]);
  return (
    <div className={styles.content}>

      <QuestionDisplay
        errorMessage={errorMessage}
        order={props.QuestionOrder}
        siblingIndex={props.SiblingIndex}
        description={props.QuestionDesc}
        notes={props.QuestionNotes} />

      <form onSubmit={onQuestionSubmit}>
        <div className={styles.formContent}>
          <AnswerInputList
            answers={props.Answers}
            choice={props.Choice}
            questionId={props.QuestionId}
            selectedAnswers={selectedAnswers}
            onRadioChange={onRadioChange}
            onCheckboxChange={onCheckboxChange} />

          <NavigationButtons
            questionOrder={props.QuestionOrder}
            isLoading
          />
<div className={styles.saveNfinishButton}>
          <ActionCall
            label={t("questionComponent_saveAndFinishLater_button", "Save and Finish later")}
            onClick={() => setOpenModal(true)}
            icon={<BsBookmark />}
            variant="NYTD" />
</div>
          <Modal open={openModal} onClose={() => setOpenModal(!openModal)} >
            <div className={styles['modalContent']}>
              <h2 className={styles['modalTitle']}>{t('saveAndFinishLaterModal_title')}</h2>
              <p>{t('saveAndFinishLaterModal_description')}</p>
              <Button
                caption={t('saveAndFinishLaterModal_saveAndLogout', "Save and Log Out")}
                variant="NYTD"
                onClick={() => handleSaveAndLogOut()}
              />
              <ActionCall label="Cancel" onClick={() => setOpenModal(false)} />
            </div>
          </Modal>
          <Alert type="caution" open={openDeclineModal} onClose={() => setOpenDeclineModal(false)}>
            <div className={styles['modalContent']}>
              <h2 className={styles['modalTitle']}>{declineModalContent.title}</h2>
              <p>{declineModalContent.description}</p>

              <Button
                option="caution"
                fullWidth
                caption={declineModalContent.yesCaption}
                onClick={() => handleDeclineSubmit()}
                variant="NYTD"
              />

              <ActionCall label={declineModalContent.noCaption} onClick={() => { setOpenDeclineModal(false); setSelectedAnswers([]) }} />

            </div>
          </Alert>

        </div>
      </form>
    </div>
  );
}

export default Question;
